<template>
  <div class="page-content">
    <div class="page-banner program_banner">
      <div class="page-banner-content">
      <p><span class="pc-browser">VALSE&nbsp;&nbsp;2026&nbsp;&nbsp;</span>SPEAKERS</p>
      </div>
    </div>
    <div class="main-container">
      <div class="content-item-grp">
        <div class="content-item" v-show="false">
          <div class="item-title">
            <span class="item-title-content">特邀报告</span>
          </div>
          <div class="item-content"  >
            <p class="content-null-info">敬请期待......</p>
          </div>
        </div>
        <div class="content-item"  v-show="false">
          <div class="item-title">
            <span class="item-title-content">主旨报告</span>
          </div>
          <div class="item-content">
            <div class="speaker-list keynote-list">
              <div class="speaker-item" v-for="item in speakers.keynote">
                <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}">
                  <!--<img :src="item.image"/>-->
                </div>
                <div class="speaker-name">{{item.name}}</div>
                <div class="speaker-org">{{item.organization}}</div>
              </div>
            </div>

          </div>
        </div>
        <div class="content-item"  v-show="true">
        <!-- <div class="item-title">
            <span class="item-title-content">特邀报告<br/><span class="item-title-label">（按报告顺序排列）</span></span>
          </div> -->
          <div class="item-content">
            <div class="speaker-list">
              <div class="speaker-item" v-for="item in speakers.invited">
                <div class="speaker-image" :style="{'background-image':'url('+item.image+')'}">
                  <!--<img :src="item.image"/>-->
                </div>
                <div class="speaker-name">{{item.name}}</div>
                <div class="speaker-org">{{item.organization}}</div>
              </div>
            </div>

          </div>
        </div>

        <div class="content-item"   v-show="true">
          <div class="item-title">
            <span class="item-title-content">
              讲者介绍
            </span>
          </div>
          <div class="item-content">
            <!--<div class="tutorial-item" v-for="item in speakers.invited">-->
              <!--&lt;!&ndash;<div class="tutorial-item-images" :style="{'background-image':'url('+item.image+')'}"></div>&ndash;&gt;-->
              <!--&lt;!&ndash;<div class="tutorial-item-intro"><span class="item-name">{{item.reportAbstract}}</span>{{item.intr}}</div>&ndash;&gt;-->

            <!--</div>-->
            <!-- <div class="workshop-speaker-item" v-for="speaker in speakers.keynote">
              
                <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div>
                <div class="speaker-item-intro">
                  <div class="item-name">{{speaker.name}}</div>
                  <div class="item-name">{{speaker.organization}}</div>
                  {{speaker.resume}}
                </div>
                <div class="report-item-contain">
                  <div class="report-title-contain">
                    <span class="report-title-label pc-browser">报告题目：</span>
                    <span class="report-title">{{speaker.reportTitle}}</span>
                  </div>

                  <div class="report-abstract" v-html="speaker.reportAbstract">
                  </div>
                </div>
              
            </div> -->
            <div class="workshop-speaker-item" v-for="speaker in speakers.keynote">
                <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div>
                <div class="speaker-item-intro">
                  <div class="item-name">{{speaker.name}}</div>
                  <div class="item-name">{{speaker.organization}}</div>
                  {{speaker.resume}}
                </div>
                <div class="report-item-contain">
                  <div class="report-title-contain">
                    <span class="report-title-label pc-browser">报告题目：</span>
                    <span class="report-title">{{speaker.reportTitle}}</span>
                  </div>

                  <div class="report-abstract" v-html="speaker.reportAbstract">
                  </div>
                </div>
            </div>
            <div class="workshop-speaker-item" v-for="speaker in speakers.invited">
                <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div>
                <div class="speaker-item-intro">
                  <div class="item-name">{{speaker.name}}</div>
                  <div class="item-name">{{speaker.organization}}</div>
                  {{speaker.resume}}
                </div>
                <div class="report-item-contain">
                  <div class="report-title-contain">
                    <span class="report-title-label pc-browser">报告题目：</span>
                    <span class="report-title">{{speaker.reportTitle}}</span>
                  </div>

                  <div class="report-abstract" v-html="speaker.reportAbstract">
                  </div>
                </div>
            </div>
            <!-- <div class="workshop-speaker-item" v-for="speaker in speakers.aprspeakers">
                <div class="speaker-item-images" :style="{'background-image':'url('+speaker.image+')'}"></div>
                <div class="speaker-item-intro">
                  <div class="item-name">{{speaker.name}}</div>
                  <div class="item-name">{{speaker.organization}}</div>
                  {{speaker.resume}}
                </div>
                <div class="report-item-contain">
                  <div class="report-title-contain">
                    <span class="report-title-label pc-browser">报告题目：</span>
                    <span class="report-title">{{speaker.reportTitle}}</span>
                  </div>

                  <div class="report-abstract" v-html="speaker.reportAbstract">
                  </div>
                </div>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <p>© VALSE 2026 All rights reserved</p>
      <!--<img src="../../static/images/other-footer-bg.png"/>-->
    </div>
  </div>
</template>

<script>
    export default {
        name: "Speaker",
      data(){
          return {
            speakers:this.$dicts.speakers,
          }
      }
    }
</script>

<style scoped>
  .footer{
    /* position: fixed; */
    bottom: 0;
  }
  .program_banner{
    background-image: url("../../static/images/sub_banner/03.jpg");
  }
  .program_banner p{
    /*color: white;*/
  }
  .item-title-label{
    font-size: 12px;
    color: #2c3e50;
    padding-top: -10px;
  }
  .speaker-list{
    display: flex;
    /* justify-content: flex-start; */
    justify-content: center;
    flex-wrap:wrap;
  }
  .speaker-list .speaker-item{
    width: 160px;
    height: 220px;
  }
  .speaker-list .speaker-image{

    width: 120px;
    height: 120px;
    margin: 12px auto;
    background-size: cover;
    background-repeat: no-repeat;
    /*background-position: center;*/
    border-radius: 30px;
  }
  .speaker-list .speaker-image img{
    max-width: 100px;
    /*max-height: 100px;*/
    vertical-align: middle;
    border-radius: 30%;
  }
  .speaker-list .speaker-name{
    color: #0053a1;
    font-weight: 500;
  }
  .keynote-list{
    justify-content: center;
  }
  .keynote-list .speaker-item{
    width: 195px;
    height: 240px;
  }
  .keynote-list .speaker-image{
    width: 165px;
    height: 165px;
  }
  .keynote-list  .speaker-name{
    font-weight: bolder;
    font-size: 18px;
  }

  .workshop-speaker-item{
    margin-bottom: 32px;
    background-color: #efefef;
    padding: 8px;
    border-radius: 10px;
  }
  .workshop-speaker-item .speaker-item-images{
    width: 120px;
    height: 120px;
    background-repeat: no-repeat;
    background-position: top;
    background-size: cover;
    border-radius: 30px;
    float:left;
    margin: 0 8px;
    /*clear: both;*/
  }
  .workshop-speaker-item .speaker-item-intro{
    text-align: justify;
    padding: 0 8px;
    padding-top: 40px;
    font-size: 16px;
  }
  .speaker-item-intro .item-name{
    margin-bottom: 8px;
    font-weight: 600;
  }
  .report-item-contain .report-title-contain{
    text-align: center;
    margin-top: 16px;
    font-size: 18px;
    color: #0053a1;
    font-weight: 700;

  }
  .report-abstract{
    text-indent: 2em;
    text-align: justify;
    padding: 0 8px;
  }
  .speakerandpanel-contain{
    margin-left: 50px;
    font-weight: 600;
  }



  @media screen  and (max-width: 800px){
    .program_banner{
      /*background-image: url("../../static/images/speaker_mobile_banner.jpg");*/
      background-size: cover;
      /*background-position: right;*/
    }
  }
  @media screen  and (max-width: 710px){
    .speaker-list{
      justify-content: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Speaker.vue